export default __webpack_public_path__ + "static/media/TopicsIconDarkBackground.4285f6f1.svg";